/**
 * Official operating documents. Files live in `public/licencas/` so they
 * open same-origin in the browser (inline view, no download attribute).
 * Replace the PDFs in that folder when Anvisa or CMVS issues a new copy.
 */
export const LICENSE_COMPANY = {
  legalName: 'Qualidoc Medicamentos LTDA',
  cnpj: '21.659.253/0002-22',
  address: 'Alameda Barros, 136, Santa Cecília, São Paulo/SP, CEP 01232-000',
  pharmacist: 'Raquel Temple Ortolon',
  crf: 'CRF 60675',
  afe: '7.72.215-5',
  cmvs: '355030801-477-011819-0-4',
} as const;

export const LICENSE_DOCUMENTS = [
  {
    id: 'autorizacao',
    title: 'Autorização de Funcionamento',
    issuer: 'Anvisa',
    referenceLabel: 'AFE',
    reference: LICENSE_COMPANY.afe,
    description:
      'Autorização federal que habilita a Qualidoc a comercializar medicamentos, emitida pela Agência Nacional de Vigilância Sanitária.',
    href: '/licencas/autorizacao-de-funcionamento.pdf',
  },
  {
    id: 'licenca',
    title: 'Licença de Funcionamento',
    issuer: 'Vigilância Sanitária Municipal',
    referenceLabel: 'CMVS',
    reference: LICENSE_COMPANY.cmvs,
    description:
      'Licença municipal que autoriza o funcionamento da farmácia no endereço de Santa Cecília, em São Paulo.',
    href: '/licencas/licenca-de-funcionamento.pdf',
  },
] as const;
